import { render } from "./ShippingView.vue?vue&type=template&id=7335cdb0&scoped=true"
import script from "./ShippingView.vue?vue&type=script&lang=js"
export * from "./ShippingView.vue?vue&type=script&lang=js"

import "./ShippingView.vue?vue&type=style&index=0&id=7335cdb0&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/user/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.12_vue@3.5.12_typescript@5.6.3__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7335cdb0"]])

export default __exports__